export default __webpack_public_path__ + "static/media/caract_img_tiny.60d2a563.png";